import type { AxiosInstance } from '@aviata/platform-client';
import type { BlogArticle } from './types';

export const blogApi = (http: AxiosInstance) => {
  return {
    getArticle(slug: string): Promise<BlogArticle> {
      return http.get(`/blog/api/posts/fullPost/?slug=${slug}`).then(res => {
        return res.data;
      });
    },
  };
};
